// extracted by mini-css-extract-plugin
module.exports = {"reviewPhotoGallery":"Vo","imageAndVideoCount":"Wo","imageAndVideoContainer":"Xo","viewAllReviews":"Yo","center":"Zo","galleryAislePlacement":"_o"};